import { render, staticRenderFns } from "./TokenImage.vue?vue&type=template&id=d4725d56&scoped=true&"
import script from "./TokenImage.vue?vue&type=script&lang=js&"
export * from "./TokenImage.vue?vue&type=script&lang=js&"
import style0 from "./TokenImage.vue?vue&type=style&index=0&id=d4725d56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4725d56",
  null
  
)

export default component.exports